import { Injectable, Injector } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

import { LogsService } from '../services/http-client/logs.service';

@Injectable()
export class WebMissingTranslationHandler implements MissingTranslationHandler {
  constructor(private injector: Injector) {}

  handle(params: MissingTranslationHandlerParams) {
    let message = 'Translations Undefined';

    if (params.translateService.translations && Object.keys(params.translateService.translations).length !== 0) {
      message = 'Current Language Undefined';

      if (params.translateService.currentLang) {
        message = `Missing Web translation for key: '${params.key}', current language: '${params.translateService.currentLang}'`;
      }

      this.injector.get(LogsService).saveWebMissingTranslationLog(message).subscribe();
    }

    return params.key;
  }
}
